import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import { supabase } from './supabaseClient';

// ── Icons (inline SVG) ──────────────────────────────────────────────
const TelegramIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.244-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" />
  </svg>
);

const SolanaIcon = () => (
  <svg width="20" height="20" viewBox="0 0 397.7 311.7" fill="currentColor">
    <path d="M64.6 237.9c2.4-2.4 5.7-3.8 9.2-3.8h317.4c5.8 0 8.7 7 4.6 11.1l-62.7 62.7c-2.4 2.4-5.7 3.8-9.2 3.8H6.5c-5.8 0-8.7-7-4.6-11.1l62.7-62.7zM64.6 3.8C67.1 1.4 70.4 0 73.8 0h317.4c5.8 0 8.7 7 4.6 11.1l-62.7 62.7c-2.4 2.4-5.7 3.8-9.2 3.8H6.5c-5.8 0-8.7-7-4.6-11.1L64.6 3.8zM333.1 120.1c-2.4-2.4-5.7-3.8-9.2-3.8H6.5c-5.8 0-8.7 7-4.6 11.1l62.7 62.7c2.4 2.4 5.7 3.8 9.2 3.8h317.4c5.8 0 8.7-7 4.6-11.1l-62.7-62.7z" />
  </svg>
);

const ArrowRight = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const ShieldIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

const BoltIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);

const GlobeIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

const CpuIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="4" width="16" height="16" rx="2" /><rect x="9" y="9" width="6" height="6" />
    <line x1="9" y1="1" x2="9" y2="4" /><line x1="15" y1="1" x2="15" y2="4" />
    <line x1="9" y1="20" x2="9" y2="23" /><line x1="15" y1="20" x2="15" y2="23" />
    <line x1="20" y1="9" x2="23" y2="9" /><line x1="20" y1="14" x2="23" y2="14" />
    <line x1="1" y1="9" x2="4" y2="9" /><line x1="1" y1="14" x2="4" y2="14" />
  </svg>
);

const CoinsIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="8" cy="8" r="6" /><path d="M18.09 10.37A6 6 0 1 1 10.34 18" />
    <path d="M7 6h1v4" /><path d="m16.71 13.88.7.71-2.82 2.82" />
  </svg>
);

// ── Chat Bubble Animation ──────────────────────────────────────────
const chatMessages = [
  { from: 'user', text: 'Send 5 USDC to solana.sol', delay: 0 },
  { from: 'bot', 
    text: `💸 Confirm this transfer?`, 
    delay: 700 
  },
  { from: 'user', text: '✅ Confirm?', delay: 1400 },
  { from: 'bot', 
    text: `🔐 Enter your 4-digit PIN to authorise:`, delay: 2100 },
  { from: 'user', text: '****', delay: 2800 },
  { from: 'bot',
    text: `🎉 Transfer Successful!
Need anything else?`, delay: 3000
   },
];

function ChatDemo() {
  const [visible, setVisible] = useState([]);
  useEffect(() => {
    chatMessages.forEach((msg, i) => {
      setTimeout(() => setVisible(v => [...v, i]), msg.delay + 600);
    });
  }, []);

  return (
    <div className="chat-demo">
      <div className="chat-header">
        <div className="chat-avatar"><img src='/bot.png'></img></div>
        <div>
          <div className="chat-name">Flexus Bot</div>
          <div className="chat-status">● Online</div>
        </div>
      </div>
      <div className="chat-messages">
        {chatMessages.map((msg, i) => (
          <div
            key={i}
            className={`chat-bubble ${msg.from} ${visible.includes(i) ? 'visible' : ''}`}
          >
            {msg.text}
          </div>
        ))}
      </div>
    </div>
  );
}

// ── Counter animation ──────────────────────────────────────────────
function CountUp({ end, suffix = '', prefix = '' }) {
  const [count, setCount] = useState(0);
  const ref = useRef();
  useEffect(() => {
    const observer = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        let start = 0;
        const step = end / 60;
        const timer = setInterval(() => {
          start += step;
          if (start >= end) { setCount(end); clearInterval(timer); }
          else setCount(Math.floor(start));
        }, 16);
        observer.disconnect();
      }
    }, { threshold: 0.5 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [end]);
  return <span ref={ref}>{prefix}{count.toLocaleString()}{suffix}</span>;
}

// ── Roadmap steps ──────────────────────────────────────────────────
const roadmapSteps = [
  { week: 'Week 1', title: 'Core & Identity', desc: 'Social IDs mapped to Solana wallets. Balance checks via chat. The brain is alive.', icon: '🧠' },
  { week: 'Week 2', title: 'P2P Power Loop', desc: 'Real USDC transfers on Solana via WhatsApp and Telegram.', icon: '🔁' },
  { week: 'Week 3', title: 'Utility Layer', desc: 'Airtime purchases & NGN bank offramps.', icon: '🌉' },
  { week: 'Week 4', title: 'Prediction Markets', desc: 'Trending bets, locked USDC, live markets. A full financial hub in your chat.', icon: '📈' },
];

const features = [
  { icon: <CpuIcon />, title: 'AI Intent Engine', desc: 'AI parses natural language into precise transaction instructions — no forms, no fields.' },
  { icon: <ShieldIcon />, title: 'MPC Shadow Wallets', desc: 'Your wallet exists but stays invisible. Import existing keys or auto-generate. Non-custodial by design.' },
  { icon: <GlobeIcon />, title: 'Web2 → Web3 Bridge', desc: 'The integrations lets you offramp USDC into airtime or Naira — in seconds.' },
  { icon: <CoinsIcon />, title: 'Prediction Markets', desc: 'Lock USDC into smart contract vaults on live market events. Earn while you chat.' },
  { icon: <BoltIcon />, title: 'Solana Speed', desc: '400ms finality, sub-cent fees.' },
  { icon: <ShieldIcon />, title: 'Pin Protection', desc: 'Transactions require PIN confirmation. Stolen phone ≠ drained wallet.' },
];

// ── Main Component ──────────────────────────────────────────────────
export default function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Waitlist state
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [message, setMessage] = useState('');

  const handleWaitlistSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setStatus('loading');
    setMessage('');

    try {
      const { error } = await supabase
        .from('waitlist')
        .insert([{ email }]);

      if (error) {
        // Check for duplicate email (Postgres error code 23505)
        if (error.code === '23505') {
          setStatus('error');
          setMessage('thank you Flexxer, this email has already been submitted, will hola at ya soon');
        } else {
          throw error;
        }
      } else {
        setStatus('success');
        setMessage('Successfully joined the waitlist! check your email for a welcome message');
        setEmail('');
      }
    } catch (error) {
      console.error('Waitlist error:', error);
      setStatus('error');
      setMessage(error.message || 'Something went wrong. Please try again later.');
    }
  };

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="app">
      {/* ── NAV ── */}
      <nav className={`nav ${scrolled ? 'nav-scrolled' : ''}`}>
        <div className="nav-inner">
          <div className="logo">
            <span className="logo-mark"><img src='/logo.png'></img></span>
            <span className="logo-name"><img height="25px" src="/prlogo.png"></img></span>
          </div>
          <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
            {['Features', 'How it works', 'Roadmap', 'Stats'].map((item, i) => (
              <li key={i} style={{ '--i': i }}>
                <a href={`#${item.toLowerCase().replace(/ /g, '-')}`} onClick={() => setMenuOpen(false)}>
                  {item}
                </a>
              </li>
            ))}
            <li className="mobile-only" style={{ '--i': 4 }}>
              <a href="#waitlist" className="btn-primary" onClick={() => setMenuOpen(false)}>
                Get Early Access
              </a>
            </li>
          </ul>
          <a href="#waitlist" className="btn-nav">Get Early Access</a>
          <button className={`hamburger ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(m => !m)}>
            <span /><span /><span />
          </button>

        </div>
      </nav>

      {/* ── HERO ── */}
      <section className="hero">
        <div className="hero-grain" />
        <div className="hero-grid" />
        <div className="hero-glow" />
        <div className="hero-content">
          <div className="hero-badge">
            <SolanaIcon /> Built on Solana
          </div>
          <h1 className="hero-title">
            Your wallet lives<br />
            <span className="title-accent">in your chat.</span>
          </h1>
          <p className="hero-sub">
            Flexus is an AI-driven headless wallet. No extensions. No seed phrases memorized.
            Just text — and your money moves on Solana.
          </p>
          <div className="hero-actions">
            <a href="#waitlist" className="btn-primary">
              Join the Waitlist <ArrowRight />
            </a>
            <a href="#how-it-works" className="btn-ghost">See how it works</a>
          </div>
          <div className="hero-platforms">
            <span>Available on</span>
            <div className="platform-pills">
              <div className="platform-pill"><TelegramIcon /> Telegram</div>
              <div className="platform-pill"><WhatsAppIcon /> WhatsApp</div>
            </div>
          </div>
        </div>
        <div className="hero-visual">
          <ChatDemo />
        </div>
      </section>

      {/* ── STATS ── */}
      <section className="stats" id="stats">
        <div className="stats-inner">
          <div className="stat">
            <div className="stat-num"><CountUp end={400} suffix="ms" /></div>
            <div className="stat-label">Transaction Finality</div>
          </div>
          <div className="stat-div" />
          <div className="stat">
            <div className="stat-num"><CountUp prefix="<$" end={1} suffix=" cent" /></div>
            <div className="stat-label">Avg. Transaction Fee</div>
          </div>
          <div className="stat-div" />
          <div className="stat">
            <div className="stat-num"><CountUp end={60} suffix="s" /></div>
            <div className="stat-label">Crypto → Bank Time</div>
          </div>
          <div className="stat-div" />
          {/* <div className="stat">
            <div className="stat-num"><CountUp end={0} suffix=" seed phrases" /></div>
            <div className="stat-label">Required from user</div>
          </div> */}
        </div>
      </section>

      {/* ── FEATURES ── */}
      <section className="features" id="features">
        <div className="section-header">
          <div className="section-tag">What's under the hood</div>
          <h2>Built different,<br /><span className="accent">by design.</span></h2>
          <p className="section-sub">Six pillars that make Flexus the most intuitive crypto wallet you'll never actually see.</p>
        </div>
        <div className="features-grid">
          {features.map((f, i) => (
            <div className="feature-card" key={i} style={{ animationDelay: `${i * 0.08}s` }}>
              <div className="feature-icon">{f.icon}</div>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── HOW IT WORKS ── */}
      <section className="how" id="how-it-works">
        <div className="how-inner">
          <div className="how-text">
            <div className="section-tag">The magic explained</div>
            <h2>From plain text<br /><span className="accent">to Solana</span></h2>
            <p className="section-sub">Three layers work in concert to turn the message into a confirmed blockchain transaction.</p>
            <ul className="how-list">
              {[
                ['Intent Parsing', 'LLM converts your text into a precise JSON action payload.'],
                ['Wallet Signing', 'Your encrypted MPC keypair signs the tx — never exposed.'],
                ['Bridge & Settle', 'Solana confirms in under a second. NGN offramp triggers instantly.'],
              ].map(([title, desc], i) => (
                <li key={i}>
                  <div className="how-step-num">{i + 1}</div>
                  <div>
                    <strong>{title}</strong>
                    <span>{desc}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="how-visual">
            <div className="flow-diagram">
              {['"Send 10 USDC to solana.sol"', 'AI Parse', 'Sign Tx', 'Solana', 'Naira'].map((label, i, arr) => (
                <React.Fragment key={i}>
                  <div className="flow-node">{label}</div>
                  {i < arr.length - 1 && <div className="flow-arrow">↓</div>}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── ROADMAP ── */}
      <section className="roadmap" id="roadmap">
        <div className="section-header">
          <div className="section-tag">4-Week Build Sprint</div>
          <h2>From zero to<br /><span className="accent">financial hub.</span></h2>
        </div>
        <div className="roadmap-track">
          {roadmapSteps.map((step, i) => (
            <div className="roadmap-card" key={i}>
              <div className="roadmap-week">{step.week}</div>
              {/* <div className="roadmap-emoji">{step.icon}</div> */}
              <h3>{step.title}</h3>
              <p>{step.desc}</p>
              <div className="roadmap-num">{String(i + 1).padStart(2, '0')}</div>
            </div>
          ))}
          <div className="roadmap-line" />
        </div>
      </section>

      {/* ── COMMANDS ── */}
      <section className="commands">
        <div className="commands-inner">
          <div className="section-tag" style={{ marginBottom: '1.5rem' }}>Things you can say</div>
          <div className="commands-grid">
            {[
              '"Send 5 USDC to you.sol"',
              '"Buy 1000 Naira airtime to 081..."',
              '"Withdraw 20 USDC to my Access Bank"',
              '"Show my transaction history"',
              '"What\'s trending on predictions?"',
            ].map((cmd, i) => (
              <div className="command-chip" key={i}>
                <CheckIcon /> {cmd}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── WAITLIST ── */}
      <section className="waitlist" id="waitlist">
        <div className="waitlist-glow" />
        <div className="waitlist-inner">
          <div className="waitlist-badge"><SolanaIcon /> Solana Devnet → Mainnet Soon</div>
          <h2>Be first to text<br /><span className="accent">your money.</span></h2>
          <p>Join the waitlist. Get early access, beta invite, and a free funded wallet on launch.</p>

          <div className="waitlist-form-container">
            {message && (
              <div className={`waitlist-message ${status}`}>
                {message}
              </div>
            )}
            <form className="waitlist-form" onSubmit={handleWaitlistSubmit}>
              <input
                type="email"
                placeholder="Enter your email address"
                className="waitlist-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={status === 'loading'}
              />
              <button className="btn-primary" type="submit" disabled={status === 'loading'}>
                {status === 'loading' ? 'Joining...' : 'Get Access'} <ArrowRight />
              </button>
            </form>
          </div>
          <div className="waitlist-note">No spam. Just Flexus.</div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="footer">
        <div className="footer-inner">
          <div className="logo">
            <span className="logo-mark"><img src='/logo.png'></img></span>
            <span className="logo-name"><img height="25px" src="/prlogo.png"></img></span>
          </div>
          <div className="footer-links">
            <a href="#features">Features</a>
            <a href="#roadmap">Roadmap</a>
            <a href="#waitlist">Waitlist</a>
          </div>
          <div className="footer-copy">© 2026 Flexus. Built on Solana.</div>
        </div>
      </footer>
    </div>
  );
}
